import SideMenuIssueDate, {menuItemIssueDate} from '../../components/SideMenuIssueDate/SideMenuIssueDate';

import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import '../DocumentationTeamHealth/DocTeamHealth.css'

const EndUserLicense = () => {
    const [inactive, setInactive] = useState(false);

    return (
      <>
            <div style={{marginTop :  "30px"}} >
  
           <SideMenuIssueDate
            onCollapse={(inactive) => {
              //console.log(inactive);
              setInactive(inactive);
            }}
          />
  
          <div className={`container ${inactive ? "inactive" : ""}`}>
            {/* improvememt, not recorded in video, its just looping through menuItems
            instead of hard coding all the routes */}
            {menuItemIssueDate.map((menu, index) => (
              <>
                <Route key={menu.name} exact={menu.exact} path={menu.to}>
                <p>Issue dates overview  documentation</p> 
                <h3>End User License Agreement (EULA)</h3>
  
                <p>Please read this End-User License agreement ("agreement ") carefully before downloading or using any Rumpelcoders Software ("Application"). By downloading or using the Application, you are agreeing to be bound by the terms and conditions of this agreement .</p>
                <p> If you do not agree to the terms of this agreement, do not download or use the Application. </p>
              
                <h3>License</h3>
                <p>Agil4You grants you a revocable, non-exclusive, non-transferable, limited license to download, install and use the Application solely for your personal purposes strictly in accordance with the terms of this agreement.</p>
                
                <h3> Restrictions </h3>
                <p>You agree not to, and you will not permit others to:</p>
                <p> a) license, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose or otherwise commercially exploit the Application or make the Application available to any third party. </p>
                
                <h3>Modifications to Application</h3>
                <p>Agil4You reserves the right to modify, suspend or discontinue, temporarily or permanently, the Application or any service to which it connects, with or without notice and without liability to you.</p>
  
  
                <h3>Term and Termination</h3>
                <p>This agreement shall remain in effect until terminated by you or Agil4You.</p>
                <p>Agil4You may, in its sole discretion, at any time and for any or no reason, suspend or terminate this agreement with or without prior notice.</p>
                <p>This agreement will terminate immediately, without prior notice from Agil4You, in the event that you fail to comply with any provision of this agreement . You may also terminate this Agreement by deleting the Application</p>
                
                <h3> Severability </h3>
                <p>If any provision of this agreement is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.</p>
  
                <h3>Amendments to this agreement</h3>
                <p>Agil4You reserves the right, at its sole discretion, to modify or replace this agreement at any time. If a revision is material we will provide at least 7 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>
                
                <h3>Warranty disclaimer</h3>
                <p>Licensor, and author of the software, hereby expressly disclaim and warranty for the software. the software and any related documentation is provided "as is" without warranty of any kind. either express or implied, including without limitation, the implied warranties of merchantability, fitness for a particular purpose, or non-infringement. licensee accepts any and all risk arising out of use or performance of the software.</p>
                
                <h3>Contact Information</h3>
                <p>If you have any questions about this agreement, please contact us.</p>
                <p style={{color:"blue"}}>contact@agil4you.com</p>
  
                
  
  
  
  
  
                
                
  
  
  
  
                </Route>
                {menu.subMenus && menu.subMenus.length > 0
                  ? menu.subMenus.map((subMenu, i) => (
                      <Route key={subMenu.name} path={subMenu.to}>
                        <h1>{subMenu.name}</h1>
                      </Route>
                    ))
                  : null}
              </>
            ))}
             
  
            {/* <Switch>
              <Route exact path={"/"}>
                <Dashboard />
              </Route>
              <Route exact path={"/content"}>
                <Content />
              </Route>
              <Route path={"/content/courses"}>
                <Courses />
              </Route>
              <Route path={"/content/videos"}>
                <Videos />
              </Route>
              <Route path={"/design"}>
                <Design />
              </Route>
              <Route exact path={"/content-2"}>
                <Content2 />
              </Route>
              <Route path={"/content-2/courses"}>
                <Courses2 />
              </Route>
              <Route path={"/content-2/videos"}>
                <Videos2 />
              </Route>
              <Route path={"/design-2"}>
                <Design2 />
              </Route>
            </Switch> */}
           
          </div>
          </div>
          
      </>
      
    )};

export default EndUserLicense;
